import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import PropTypes from 'prop-types';
import { clone } from 'lodash';
import * as actions from 'state/modules/assign';
import styles from './InspectionCommentPopup.css';

class InspectionCommentPopup extends Component {
  static propTypes = {
    propState: PropTypes.bool,
    wholeData: React.PropTypes.shape({}),
    inspectionsDataAll: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    updateInspectionsData: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    closePopup: React.PropTypes.func
  }

  state = {
    active: this.props.propState,
    comments: '',
    showError: false
  }

  componentWillMount() {
    const wholeData = this.props.wholeData;
    this.setState({ comments: wholeData.cica_comments ? wholeData.cica_comments : '' });
  }

  updateInspectionData = () => {
    const inspectionData = this.props.wholeData;
    const dataId = inspectionData.id;
    let correctData = {};
    if (this.state.comments) {
      this.props.inspectionsDataAll.forEach((data) => {
        if (data.id.indexOf(dataId) > -1) {
          correctData = clone(data);
          correctData.cica_comments = this.state.comments; // eslint-disable-line
        }
      });
      this.props.updateInspectionsData(correctData);
      this.props.closePopup();
    } else {
      this.setState({ showError: true });
    }
  }

  saveComments = (comments) => {
    this.setState({ comments }, () => {
      if (this.state.comments) {
        this.setState({ showError: false });
      }
    });
  }

  render() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.inputContainer}>
          <Input
            type="text"
            multiline
            name="Comments"
            display="flex"
            theme={styles}
            floating={false}
            maxLength="150"
            onChange={this.saveComments}
            value={this.state.comments}
            className={this.state.showError ? styles.showError : styles.noError}
          />
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.updateInspectionData()}
            >{strings.save}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closePopup()}
            >{strings.cancel}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inspectionsDataAll: state.assign.inspectionsData
});

export default connect(mapStateToProps, actions)(InspectionCommentPopup);



// WEBPACK FOOTER //
// ./src/components/InspectionCommentPopup/InspectionCommentPopup.js